import { GetUserPostsDocument } from '%screens/profile/UserFeed/__generated__/userPosts.generated';
import {
	usePinPostMutation,
	useUnpinPostMutation,
} from '../actions/__generated__/pin.mutation.generated';

export const useTogglePinPost = ({ postId, isPinned }: { postId: string; isPinned: boolean }) => {
	const options = {
		variables: { postId },
		refetchQueries: [GetUserPostsDocument],
	};
	const [pinPost, { loading: pinPostLoading }] = usePinPostMutation(options);
	const [unpinPost, { loading: unpinPostLoading }] = useUnpinPostMutation(options);

	const isLoading = pinPostLoading || unpinPostLoading;

	const togglePinPost = () => {
		if (isLoading) {
			return;
		}

		return isPinned ? unpinPost() : pinPost();
	};

	return {
		togglePinPost,
		isLoading,
	};
};
